<template>
    <dtg-action :class="b({ disabled })" :disabled="disabled">
        <dtg-icon :class="b('icon')" :name="iconName" />
        <span :class="b('text')">
            <slot />
        </span>
    </dtg-action>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

import { DtgAction, DtgIcon, DtgIconName, getName, iconNames, inArray, useBem } from 'dtg-components';

import styles from './style.module.scss';

export default defineComponent({
    name: getName(styles),

    components: {
        DtgAction,
        DtgIcon,
    },

    props: {
        iconName: {
            type: String as PropType<DtgIconName>,
            required: true,
            validator: inArray<DtgIconName>(iconNames),
        },

        disabled: {
            type: Boolean,
            default: false,
        },
    },

    setup() {
        return {
            b: useBem(styles),
        };
    },
});
</script>
